import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RouteMeta } from "./lib/seo";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import EventDetail from "./pages/EventDetail";
import MapPage from "./pages/MapPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Propose from "./pages/Propose";
import Why from "./pages/Why";
import Admin from "./pages/Admin";
import { Privacy, Terms, About } from "./pages/Legal";

function Shell() {
  const location = useLocation();
  const bare = ["/login", "/register"].includes(location.pathname);
  return (
    <div className="App min-h-screen flex flex-col">
      <RouteMeta />
      {!bare && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/evento/:id" element={<EventDetail />} />
          <Route path="/mappa" element={<MapPage />} />
          <Route path="/perche-wyd" element={<Why />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profilo" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/proponi" element={<Propose />} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termini" element={<Terms />} />
          <Route path="/chi-siamo" element={<About />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <CookieBanner />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
